import * as types from '@/store/mutation-types'
import { saveAs } from 'file-saver'
import { Repository } from '@/repository/repository'
import { stripPayload } from '@/schemas'
import { services } from '@/services'

import config from '../../../config'

const apiRepository = Repository.call('orders')
const _formatDate = receiveDate => {
  const date = new Date(receiveDate)
  const dateString = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().split('T')[0]

  return dateString
}

const _formatHour = hour => {
  const hourToString = hour.toTimeString().split(' ')[0]
  const splitHour = hourToString.split(':')

  return `${splitHour[0]}:${splitHour[1]}`
}

const _dateTimestamp = date => new Date(date).getTime()

const _sendFiles = (orders, order, file) => {
  const orderFiltered = orders.find(o => o.id === order)
  const uploadFileData = {
    customerOrderCode: orderFiltered.customerOrderCode,
    storeCode: orderFiltered.store.storeCode,
    proofOfDelivery: file
  }

  return apiRepository.uploadProofDeliveries(uploadFileData)
}

const state = {
  orders: [],
  actions: {},
  totalCount: 0
}

const getters = {
  orders: state => state.orders,
  actions: state => state.actions,
  totalCount: state => state.totalCount
}

const actions = {
  async getOrders ({ commit }, payload) {
    const { filters = '', options } = payload

    if (filters.sort && filters.sort === 'deliveryPeriodMorning') {
      filters.sort = 'deliveryPeriod'
      filters.ord = 'desc'
    }

    if (filters.sort && filters.sort === 'deliveryPeriodAfternoon') {
      filters.sort = 'deliveryPeriod'
      filters.ord = 'asc'
    }

    const params = {
      order: filters.order || ' ',
      deliveryDateBegin: filters.deliveryDateBegin || ' ',
      deliveryDateEnd: filters.deliveryDateEnd || ' ',
      sort: filters.sort || 'customerOrderCode',
      ord: filters.ord || 'asc',
      requestURL: options || 'resourceGetOrders',
      page: filters.page || 0
    }

    const orders = await apiRepository.getCustomerOrders(params)
    const totalCount = orders.headers['x-total-count'] || 0
    if (!orders.level) return orders

    const response = services.cleanResponseService(stripPayload(orders.data, 'orders'))
    commit(types.SET_ORDERS_OPEN, {
      response,
      totalCount
    })

    return orders
  },
  async getEdfOrders ({ commit }, { filters }) {
    const params = {
      storeCode: (filters.store && filters.store.storeCode) ? filters.store.storeCode : null,
      customerOrderCode: filters.order || null,
      supplierOrderCode: filters.orderBo || null,
      status: filters.orderState || null,
      deliveryDateFrom: filters.promisseDateBegin || null,
      deliveryDateTo: filters.promisseDateEnd || null,
      partnerExpectedCollectionDateFrom: filters.collectionDateBegin || null,
      partnerExpectedCollectionDateTo: filters.collectionDateEnd || null,
      sort: filters.sort || '',
      ord: filters.ord || 'asc',
      page: filters.page || 0
    }

    const orders = await apiRepository.getEdfOrders(params)
    const totalCount = orders.headers['x-total-count'] || 0
    if (!orders.level) return orders

    const response = services.cleanResponseService(stripPayload(orders.data, 'orders'))
    commit(types.SET_ORDERS_OPEN, {
      response,
      totalCount
    })

    return orders
  },
  async setChanges ({ state, commit }, params) {
    // ! Changed Endpoints on MOVIMENT-1206, changed status needs another endpoints
    if (params.type === 'ON_EXPEDITION') return this.dispatch('orders/setSpecialActionsOrder', params)

    let data = params.orders.map((order, index) => {
      const dataToSend = {
        customerOrderCode: params.orderCodes[index],
        storeCode: params.storeCodes[index],
        status: params.type,
        damagedOrder: false
      }

      if (params.data.deliveryReasson) dataToSend.reason = params.data.deliveryReasson
      if (params.data.periodBy) dataToSend.deliveryPeriod = params.data.periodBy
      if (params.data.vehicleRegistration) dataToSend.vehicleRegistration = params.data.vehicleRegistration
      if (params.data.newDeliveryHour) {
        const hourFormated = _formatHour(params.data.newDeliveryHour)
        dataToSend.confirmedDeliveryDate = `${params.data.newDeliveryDate} ${hourFormated}`
      }

      return dataToSend
    })

    if (params.podFile) {
      params.orders.forEach(order => _sendFiles(state.orders, order, params.podFile))
    }

    const setChanges = await apiRepository.putOrderChanges(data)
    return setChanges
  },

  async uploadPodFile ({ state, commit }, params) {
    const file = await _sendFiles(state.orders, params.orders[0], params.podFile)
    return file
  },
  async setSpecialActionsOrder ({ commit }, payload) {
    const data = payload.orders.map(order => {
      return {
        effectiveStatus: payload.type || payload.type.name,
        id: order
      }
    })

    const orders = await apiRepository.putEditOrdersStatus(data)
    return orders
  },
  async download ({ commit }, filters) {
    if (filters.sort && filters.sort === 'deliveryPeriodMorning') {
      filters.sort = 'deliveryPeriod'
      filters.ord = 'desc'
    }

    if (filters.sort && filters.sort === 'deliveryPeriodAfternoon') {
      filters.sort = 'deliveryPeriod'
      filters.ord = 'asc'
    }

    const params = {
      order: filters.order || ' ',
      deliveryDateBegin: filters.deliveryDateBegin || ' ',
      deliveryDateEnd: filters.deliveryDateEnd || ' ',
      sort: filters.sort || 'customerOrderCode',
      ord: filters.ord || 'asc'
    }

    const file = await apiRepository.getDownload(params)
    if (!file.level) return file

    const timeStamp = Math.floor(Date.now())
    const blob = new Blob([file.data], { type: 'application/vnd.ms-excel' })
    saveAs(blob, `${timeStamp}.xlsx`)

    return file
  },
  async downloadEdfFile ({ commit }, filters) {
    const params = {
      storeCode: (filters.store && filters.store.storeCode) ? filters.store.storeCode : null,
      customerOrderCode: filters.order || null,
      supplierOrderCode: filters.orderBo || null,
      status: filters.orderState || null,
      deliveryDateFrom: filters.promisseDateBegin || null,
      deliveryDateTo: filters.promisseDateEnd || null,
      partnerExpectedCollectionDateFrom: filters.collectionDateBegin || null,
      partnerExpectedCollectionDateTo: filters.collectionDateEnd || null,
      sort: filters.sort || ''
    }

    const file = await apiRepository.getdownloadForEdf(params)
    if (!file || file.status !== 200) return false

    const timeStamp = Math.floor(Date.now())
    const blob = new Blob([file.data], { type: 'application/vnd.ms-excel' })
    saveAs(blob, `${timeStamp}.xlsx`)
    return file
  },
  async setIncidence ({ rootGetters, commit }, params) {
    const customerOrdersInfo = params.orders.map(oID => {
      const filteredOrder = rootGetters['orders/orders'].filter(order => order.id === oID)
      const intialDataToSend = {
        customerOrderCode: filteredOrder[0].customerOrderCode,
        storeCode: filteredOrder[0].store.storeCode
      }

      if (params.file) {
        intialDataToSend.proofOfConditions = params.file
        apiRepository.uploadImg(intialDataToSend)
      }

      return {
        customerOrderCode: intialDataToSend.customerOrderCode,
        storeCode: intialDataToSend.storeCode,
        type: 'INCIDENCE'
      }
    })

    const data = {
      momentId: params.moments.idChild || null,
      typeId: params.types.idChild || null,
      subTypeId: params.subTypes.idChild || null,
      motivsId: params.motivs.idChild || null,
      customerOrdersInfo
    }

    const setChanges = await apiRepository.addIncidence(data)
    return setChanges
  },
  async setReschedule ({ rootGetters, commit }, params) {
    const customerOrdersInfo = params.orders.map(oID => {
      const filteredOrder = rootGetters['orders/orders']
        .filter(order => order.id === oID)

      return {
        customerOrderCode: filteredOrder[0].customerOrderCode,
        storeCode: filteredOrder[0].store.storeCode,
        type: 'RESCHEDULE',
        newDeliveryDateInMillis: _dateTimestamp(params.date)
      }
    })

    const data = {
      momentId: params.moments.idChild || null,
      typeId: params.types.idChild || null,
      subTypeId: params.subTypes.idChild || null,
      reasonId: params.details.idChild || null,
      customerOrdersInfo
    }

    const setChanges = await apiRepository.addReschedule(data)
    return setChanges
  },
  async setRescheduleDateTime ({ rootGetters, commit }, params) {
    const dataToSend = params.orders.map(oID => {
      const filteredOrder = rootGetters['orders/orders']
        .filter(order => order.id === oID)

      return {
        id: filteredOrder[0].id,
        status: 'COLLECTION_SCHEDULE_DATE',
        partnerExpectedCollectionDate: `${_formatDate(params.date)} 00:00`,
        deliveryPeriod: params.periodBy
      }
    })

    const setChanges = await apiRepository.putRescheduleDateTime(dataToSend)
    return setChanges
  },
  flush ({ commit }) {
    commit(types.SET_FLUSH_ORDERS)
  }
}

const mutations = {
  [types.SET_ORDERS_OPEN] (state, { response, totalCount = 0 }) {
    state.orders = [ ...response ]
    state.actions = { ...config.data }
    state.totalCount = totalCount
  },
  [types.SET_FLUSH_ORDERS] (state) {
    state.orders.length = 0
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/orders.js